module.exports = __webpack_public_path__ + "img/public/siteImages/appStore.svg?4bbf92eb";